import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { apiInstance } from '../../axiosApi';

export const timezoneListGet = createAsyncThunk('admin/time-zone', async (params) => {
  return await apiInstance.get('/time-zone', { params });
});

export const timezoneOptionGet = createAsyncThunk('admin/time-zone-options', async () => {
  return await apiInstance.get('/time-zone');
});

export const timezoneDelete = createAsyncThunk('admin/time-zone-delete', async (id) => {
  return await apiInstance.delete(`/time-zone/${id}`);
});

export const timezoneAdd = createAsyncThunk('admin/time-zone-add', async (payload) => {
  return await apiInstance.post('/time-zone', payload);
});

export const timezoneUpdate = createAsyncThunk('admin/time-zone-update', async (payload) => {
  const { id, ...rest } = payload;
  return await apiInstance.put(`/time-zone/${id}`, rest);
});

const initialState = {
  timezoneList: null
};

const timezoneSlice = createSlice({
  name: 'timezone',
  initialState,
  reducers: {
    clearTimezoneSlice: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(timezoneListGet.fulfilled, (state, action) => {
      state.timezoneList = action?.payload;
    });
  }
});

export default timezoneSlice.reducer;
export const { clearTimezoneSlice } = timezoneSlice.actions;

export const selectTimezoneList = (state) => state.timezone.timezoneList;
export const useTimezoneList = () => {
  const timezoneList = useSelector(selectTimezoneList);
  return useMemo(() => timezoneList, [timezoneList]);
};
